import type { ApiResponse } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('auth_token');
  const headers: HeadersInit = { 'Content-Type': 'application/json', ...options.headers };
  if (token) (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  if (window.Telegram?.WebApp?.initData) {
    (headers as Record<string, string>)['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, { ...options, headers });
  const data: ApiResponse<T> = await response.json();
  if (!response.ok || !data.success) throw new Error(data.error || 'Unknown error');
  return data.data as T;
}

// ============================================
// TYPES
// ============================================

export interface StoryResponse {
  imageIndex: number;
  text: string;
}

export interface SituationResponse {
  index: number;
  text: string;
  switches: {
    social: 'solo' | 'with_people';
    intensity: 'calm' | 'intense';
    voice: 'spoke' | 'silent';
    action: 'left' | 'stayed';
  };
}

export interface ValuesResponse {
  topValues: string[];
  fork: 'freedom' | 'stability';
  horizon: 'week' | 'month' | '3months';
}

export interface MiniSJTResponse {
  question: string;
  best: string;
  worst: string;
}

export interface BatteryBResult {
  scores: Record<string, number>;
  aiTags: Array<{ tag: string; confidence: number; imageIndex: number }>;
}

// ============================================
// API
// ============================================

export async function submitBatteryBComplete(data: {
  stories: StoryResponse[];
  situations: SituationResponse[];
  values: ValuesResponse;
  miniSjt: MiniSJTResponse[];
}): Promise<BatteryBResult> {
  return request<BatteryBResult>('/battery-b/complete', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
